/* mypka-slider-tastatur.js — myPKA, 28.08.2026 (Felix)
 * Ticket 869er0z14 (shopweite Ursache) · 869eqzxmm / AC-07 (Nachweisstelle)
 *
 * WAS: Macht JEDE Swiper-Punktleiste dieses Shops mit der Tastatur bedienbar.
 * WCAG 2.2 SC 2.1.1 (Tastatur), Stufe A — und ueber SC 1.4.10 auch ein
 * Desktop-Fall, weil 1280 px bei 400 % Zoom 320 CSS-Pixel sind.
 *
 * DER BEFUND (Vera, 28.08., mit echten CDP-Ereignissen; von mir vor dem Fix
 * reproduziert — messmethode/t3-tastatur-felix.js):
 *   echter Klick / echter Tipp auf Punkt 3 -> activeIndex 0 -> 2
 *   echtes Enter / echtes Space auf Punkt 3 -> activeIndex 0 -> 0
 * Ursache: die Punktleisten laufen mit `pagination.type: 'custom'`. Damit
 * sieht Swipers a11y-Modul `bullets.length = 0` und verdrahtet keine
 * Tastenbehandlung; `keyboard.enabled` steht auf `false`. Ein
 * `<span role="button">` erzeugt aus einem Tastendruck von sich aus KEINEN
 * Klick — das tut der Browser nur fuer <button> und <a href>.
 *
 * WARUM EINE ZENTRALE DATEI STATT EINER AENDERUNG IN card-slider.js:
 * Das Muster ist im Theme 16-mal kopiert — card-slider, popular-products,
 * product-slider, recommended-slider, products-grid, categories-list,
 * simple-cards, multicolumn, featured-blog, media, card-grid, image-tabs,
 * recently-viewed, global, mypka-quizslider (gezaehlt ueber
 * `grep -l "type: 'custom'" assets/*.js`). Sechzehn gleichlautende Patches
 * waeren sechzehn Stellen, an denen ein Theme-Update den Fix wieder
 * herausnimmt, und die naechste kopierte Sektion haette ihn ohnehin nicht.
 * Delegation am Dokument trifft alle auf einmal, auch kuenftige, und fasst
 * KEINE Fremddatei an. Die drei in AC-03 genannten Slider liegen in drei
 * verschiedenen Dateien (Quiz = mypka-quizslider.js, Community-Slider =
 * card-slider.js, Popular Products = popular-products.js) — genau der Grund,
 * warum die Reparatur nicht in eine davon gehoert.
 *
 * DIE LEISTE IST DER ANKER, NICHT DIE DATEI:
 * Alle Leisten des Themes tragen `swiper-pagination`, alle Punkte
 * `swiper-pagination-bullet` (Swipers Vorgabewerte, im Markup nachgesehen:
 * sections/card-slider.liquid:81, sections/mypka-fotoslider.liquid:318,
 * snippets/swiper-nav.liquid:2). Deshalb reicht ein Selektorpaar.
 *
 * ---------------------------------------------------------------------------
 * HAELFTE 1 — PFEILTASTEN, ABER NUR SOLANGE DIE LEISTE DEN FOKUS HAT
 *
 * Swipers Tastaturmodul liegt im Bundle und ist nur ausgeschaltet. Es
 * global einzuschalten (`keyboard: { enabled: true }`) hat aber einen Preis,
 * den ich gemessen habe, statt ihn anzunehmen
 * (messmethode/t3-probe-tastaturmodul-felix.js, Produktseite 390 px,
 * 6 Instanzen):
 *
 *   Taste       Modul AUS (Auslieferung)      Modul global EIN
 *   PageUp      Seite scrollt -804 px         Seite scrollt   0 px  <- tot
 *   PageDown    Seite scrollt +823 px         Seite scrollt +422 px <- gekappt
 *   ArrowRight  0 von 6 Slidern bewegt        2 von 6 Slidern bewegt
 *
 * Grund: das Modul haengt seinen keydown-Handler ans DOKUMENT (Swiper 8.4.3,
 * im Bundle nachgelesen) und ruft preventDefault() fuer PageUp/PageDown
 * (`pageUpDown` steht per Vorgabe auf `true`), sobald irgendein Slider im
 * Viewport liegt. Wer SC 2.1.1 repariert und dabei das Blaettern mit
 * PageUp/PageDown shopweit abschaltet, hat kein Kriterium erfuellt, sondern
 * eines gegen ein anderes getauscht — und „ein Pfeil bewegt zwei Slider" ist
 * keine Bedienung, sondern ein Nebeneffekt.
 *
 * Deshalb wird das Modul an den Fokus gebunden: es geht an, wenn der Fokus in
 * eine Punktleiste faellt, und wieder aus, wenn er sie verlaesst. Dasselbe
 * Muster, das assets/mypka-fotoslider.js seit dem 21.08. fuer die
 * Grossansicht nutzt (`keyboard.enable()` beim Oeffnen, `.disable()` beim
 * Schliessen) — kein zweites Verhalten fuer denselben Handgriff.
 * Zusaetzlich wird `pageUpDown` auf `false` gesetzt: PageUp/PageDown behalten
 * ihre Dokumentbedeutung auch dann, wenn ein Punkt gerade den Fokus hat.
 * ArrowUp/ArrowDown bleiben unangetastet — bei einem waagerechten Slider
 * ruft das Modul dafuer kein preventDefault (gemessen: Seite scrollt weiter
 * 40 px), das Blaettern nach oben und unten bleibt also erhalten.
 *
 * ---------------------------------------------------------------------------
 * HAELFTE 2 — ENTER UND SPACE AUF DEM PUNKT
 *
 * Ausgeloest wird mit einem ECHTEN `click`-Ereignis auf dem Punkt, nicht mit
 * eigener slideTo-Rechnung. Swipers Klickbehandlung haengt delegiert an der
 * Leiste und rechnet Index, `slidesPerGroup` und `loop` selbst aus; sie zu
 * kopieren hiesse, dieselbe Rechnung ein zweites Mal zu pflegen. So ist
 * AC-04 („dieselbe Aktion wie ein Klick") konstruktiv erfuellt und nicht nur
 * nachgemessen.
 *
 * Enter loest auf keydown aus, Space auf keyup — das ist exakt das Verhalten
 * eines echten <button> (ARIA Authoring Practices, Button Pattern). Space
 * bekommt auf keydown trotzdem ein preventDefault, sonst blaettert die Seite
 * unter dem Finger weg (gemessen: +809 px bei 390 px).
 *
 * ---------------------------------------------------------------------------
 * HAELFTE 3 — DIE, DIE IM TICKET NOCH NICHT STAND: FOKUS RETTEN
 *
 * `type: 'custom'` rendert die Leiste bei JEDEM Slidewechsel komplett neu
 * (`$el.html(renderCustom(...))`). Der Punkt, auf dem der Fokus stand, wird
 * dabei aus dem Dokument entfernt — der Fokus faellt auf <body> zurueck.
 * Ohne Gegenmassnahme koennte ein Tastaturnutzer den Slider genau EINMAL
 * bedienen und muesste danach von vorn durch die Seite tabben. Ein Weg, den
 * man nur einmal gehen kann, ist kein Weg.
 * Deshalb: Index merken, nach dem Neuaufbau denselben Punkt wieder
 * fokussieren — `preventScroll`, damit die Seite dabei nicht springt.
 * Gilt fuer Enter/Space UND fuer die Pfeiltasten (die Leiste wird auch dann
 * neu gebaut).
 */
(() => {
	const LEISTE = '.swiper-pagination';
	const PUNKT = '.swiper-pagination-bullet';
	/* Elemente, die der Browser von sich aus per Taste aktiviert. Bei denen
	 * duerfen wir NICHT mitmischen — sonst faellt die Aktion doppelt an.
	 * Im Auslieferungsstand sind alle Punkte <span>; die Wache gilt dem Tag,
	 * das ein spaeteres Theme-Update dort hineinschreiben koennte. */
	const NATIV = 'button, a[href], input, select, textarea, summary';

	const leisteVon = (swiper) => {
		const p = swiper && swiper.pagination;
		if (!p) return null;
		return p.el || (p.$el && p.$el[0]) || null;
	};

	/* Die Instanz zu einer Leiste. NICHT ueber closest(): bei allen drei
	 * gemessenen Slidern liegt die Leiste als GESCHWISTER neben der Buehne,
	 * nicht darin. Erst der billige Weg (Vorfahren), dann der sichere
	 * (Vollscan) — und das Ergebnis bleibt an der Leiste haengen. Ein
	 * Vollscan pro erstem Fokus ist bezahlbar; ein falsch geratener Selektor
	 * waere ein stiller Ausfall. */
	const instanzZu = (leiste) => {
		if (leiste.mypkaSwiperTreffer !== undefined) return leiste.mypkaSwiperTreffer;
		let treffer = null;
		for (let n = leiste.parentElement; n && !treffer; n = n.parentElement) {
			if (n.swiper && leisteVon(n.swiper) === leiste) treffer = n.swiper;
		}
		if (!treffer) {
			treffer =
				[...document.querySelectorAll('*')]
					.map((e) => e.swiper)
					.filter(Boolean)
					.find((s) => leisteVon(s) === leiste) || null;
		}
		leiste.mypkaSwiperTreffer = treffer;
		return treffer;
	};

	/* Index merken und nach dem Neuaufbau der Leiste zurueckgeben.
	 * Zwei Anlaeufe, weil Swiper die Leiste je nach Ereigniskette im selben
	 * Frame oder erst im naechsten neu schreibt. */
	const fokusRetten = (leiste) => {
		const aktiv = document.activeElement;
		const punkt = aktiv && aktiv.closest ? aktiv.closest(PUNKT) : null;
		if (!punkt || !leiste.contains(punkt)) return;
		const i = [...leiste.querySelectorAll(PUNKT)].indexOf(punkt);
		if (i < 0) return;
		const zurueck = () => {
			if (leiste.contains(document.activeElement)) return;
			const neu = leiste.querySelectorAll(PUNKT)[i];
			if (neu) neu.focus({ preventScroll: true });
		};
		requestAnimationFrame(() => {
			zurueck();
			requestAnimationFrame(zurueck);
		});
	};

	const ausloesen = (punkt, leiste) => {
		fokusRetten(leiste);
		punkt.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
	};

	const trefferAus = (event) => {
		const ziel = event.target;
		if (!ziel || !ziel.closest) return null;
		const punkt = ziel.closest(PUNKT);
		if (!punkt || punkt.matches(NATIV)) return null;
		const leiste = punkt.closest(LEISTE);
		return leiste ? { punkt, leiste } : null;
	};

	/* Space wird zwischen keydown und keyup gehalten. Der Merker verhindert,
	 * dass ein keyup ohne zugehoeriges keydown (Fokus kam erst waehrend des
	 * Drucks auf den Punkt) etwas ausloest. */
	let spaceOffen = null;

	document.addEventListener('keydown', (event) => {
		if (event.ctrlKey || event.metaKey || event.altKey) return;
		const t = trefferAus(event);
		if (!t) return;

		if (event.key === 'Enter') {
			event.preventDefault();
			spaceOffen = null;
			ausloesen(t.punkt, t.leiste);
			return;
		}
		if (event.key === ' ' || event.key === 'Spacebar') {
			/* preventDefault schon hier: sonst blaettert die Seite, waehrend
			 * die Taste unten ist. Ausgeloest wird trotzdem erst auf keyup. */
			event.preventDefault();
			if (!event.repeat) spaceOffen = t.punkt;
			return;
		}
		/* Pfeiltasten bewegt Swipers Modul selbst (siehe oben). Hier wird nur
		 * der Fokus vorgemerkt, weil die Leiste dabei neu gebaut wird. */
		if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') fokusRetten(t.leiste);
	});

	document.addEventListener('keyup', (event) => {
		if (event.key !== ' ' && event.key !== 'Spacebar') return;
		const punkt = spaceOffen;
		spaceOffen = null;
		if (!punkt) return;
		const t = trefferAus(event);
		if (!t || t.punkt !== punkt) return;
		event.preventDefault();
		ausloesen(t.punkt, t.leiste);
	});

	/* Fokus verlaesst das Fenster -> gehaltenes Space verfaellt. */
	window.addEventListener('blur', () => {
		spaceOffen = null;
	});

	// --- Pfeiltasten: Modul an den Fokus binden ------------------------------
	let aktiveInstanz = null;

	const abschalten = () => {
		if (aktiveInstanz && aktiveInstanz.keyboard) aktiveInstanz.keyboard.disable();
		aktiveInstanz = null;
	};

	document.addEventListener('focusin', (event) => {
		const ziel = event.target;
		const leiste = ziel && ziel.closest ? ziel.closest(LEISTE) : null;
		if (!leiste) {
			abschalten();
			return;
		}
		const swiper = instanzZu(leiste);
		if (!swiper || !swiper.keyboard) {
			abschalten();
			return;
		}
		if (swiper === aktiveInstanz) return;
		abschalten();
		/* pageUpDown ausdruecklich aus: PageUp/PageDown behalten ihre
		 * Dokumentbedeutung, auch waehrend ein Punkt den Fokus haelt. */
		if (swiper.params && swiper.params.keyboard) swiper.params.keyboard.pageUpDown = false;
		swiper.keyboard.enable();
		aktiveInstanz = swiper;
	});

	document.addEventListener('focusout', () => {
		/* Verzoegert pruefen: beim Neuaufbau der Leiste liegt der Fokus fuer
		 * einen Moment auf <body>, bevor fokusRetten ihn zurueckgibt. Ein
		 * sofortiges Abschalten wuerde das Modul mitten in der Bedienung
		 * ausknipsen. */
		setTimeout(() => {
			const aktiv = document.activeElement;
			if (aktiv && aktiv.closest && aktiv.closest(LEISTE)) return;
			abschalten();
		}, 0);
	});
})();
